(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["facets"] && !Shopify.designMode) return;
  try {
    customElements.whenDefined('facet-filters-form').then(function () {
    var FacetFiltersForm = customElements.get('facet-filters-form');
    if (!FacetFiltersForm) return;

    // Read the live form and keep every checked value that shares a name.
    // set() only kept the last one in each filter group.
    FacetFiltersForm.prototype.createSearchParams = function () {
      var sortForm = document.querySelector('form[data-form-type="sort"]');
      var filtersForm = document.querySelector('form[data-form-type="filters"]');
      var params = new URLSearchParams();

      [sortForm, filtersForm].forEach(function (form) {
        if (!form) return;
        new FormData(form).forEach(function (value, key) {
          if (value !== '') params.append(key, value);
        });
      });

      var query = new URLSearchParams(window.location.search).get('q');
      if (query) params.set('q', query);

      return params.toString();
    };

    // Skip remorphing the checkbox list. Only refresh the product grid.
    FacetFiltersForm.prototype.onChange = function (searchParams) {
      this.params = searchParams;
      this.loading = true;
      this.updateProductsGrid();
    };
  });
  } catch(e) { console.error(e); }
})();

})();
